var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#0057A0",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.981 6.773l-3.62 4.138a.987.987 0 0 1-.731.339.955.955 0 0 1-.73-.34L4.013 8.729a1.112 1.112 0 0 1 .046-1.487.96.96 0 0 1 1.4.049l1.186 1.358 2.89-3.314a.947.947 0 0 1 1.4-.048c.396.404.427 1.066.046 1.487"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedbox);
export default __webpack_public_path__ + "static/media/checkedbox.73d37bae93f647699163cf412d7281a6.svg";
export { ForwardRef as ReactComponent };